import React from "react";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { StyledBlockLabel, StyledFormBlock, StyledInputBlock } from "../../../styles/styledTabsForm";
import { TextField } from "@material-ui/core";

const VerificationSchemaInfo = ({ verificationSchema }) => {
  const { t } = useTranslation("verificationSchemaPage");

  if (!verificationSchema) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (verificationSchema.length === 0) {
    return <Alert severity="warning">Нет схемы верификации</Alert>;
  }

  return (
    <>
      <Helmet>
        <title>{t("details.meta.title")} {verificationSchema.serviceRelationships.currency.asset}/{verificationSchema.serviceRelationships.service.name} • eXsoft.io</title>
      </Helmet>
      <StyledFormBlock>
        <StyledBlockLabel>
          {t("details.changeForm.schema")}
        </StyledBlockLabel>
        <StyledInputBlock>
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.project")}
            type="text"
            value={verificationSchema.project.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.service")}
            type="text"
            value={verificationSchema.serviceRelationships.service.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.currency")}
            type="text"
            value={verificationSchema.serviceRelationships.currency.asset}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.paymentSystem")}
            type="text"
            value={verificationSchema.serviceRelationships.paymentSystem.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
          <TextField
            className="grid-form__input"
            label={t("details.changeForm.schema")}
            type="text"
            value={verificationSchema.schema.name}
            variant="filled"
            InputProps={{
              readOnly: true
            }}
          />
        </StyledInputBlock>
        <div className="clear-column" />
      </StyledFormBlock>
    </>
  );
};

export default VerificationSchemaInfo;